<template>
  <div class="scroll-wrapper">
    <div class="scheduler-page">
      <Teleport v-if="isDesktop" to="#app-header-tools">
        <div class="scheduler-branch-select">
          <CityOfficeSelect v-model="selectedBranchId" />
        </div>
      </Teleport>
      <el-tabs v-model="activeTab" class="tabs">
      <el-tab-pane label="Текущие смены" name="current">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="filteredSchedules"
              :loading="isLoading"
              @update-shifts="onUpdateShifts"
              @delete-shifts="onDeleteShifts"
            />
          </template>
        </el-skeleton>
        <el-button
          type="primary"
          class="create-shift-btn"
          @click="scheduleDialogVisible = true">Создать смену</el-button>
      </el-tab-pane>
      <el-tab-pane label="История смен" name="history">
        <el-skeleton :loading="isLoading" animated>
          <template #default>
            <shift-table
              :type="activeTab"
              :users="filteredSchedules"
              :loading="isLoading"
            />
          </template>
        </el-skeleton>
      </el-tab-pane>
      <el-tab-pane label="Шаблоны смен" name="templates">
        <shift-template-manager />
      </el-tab-pane>
    </el-tabs>

      <create-schedule-dialog
        v-model="scheduleDialogVisible"
      />
    </div>
  </div>
</template>
<script>
import ShiftTable from '@/components/util/scheduler/ShiftTable.vue'
import CreateScheduleDialog from '@/components/util/scheduler/CreateScheduleDialog.vue'
import ShiftTemplateManager from '@/components/util/scheduler/ShiftTemplateManager.vue'
import CityOfficeSelect from '@/components/util/calendar/CityOfficeSelect.vue'
import { mapActions, mapState } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'SchedulerPage',
  components: {
    ShiftTable,
    CreateScheduleDialog,
    ShiftTemplateManager,
    CityOfficeSelect
  },
  data() {
    return {
      activeTab: 'current',
      scheduleDialogVisible: false,
      isLoading: false,
      selectedBranchId: null,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1440
    }
  },
  computed: {
    ...mapState('schedules', ['schedules']),
    ...mapState('cities', ['cities']),
    isDesktop() {
      return this.viewportWidth >= 992
    },
    filteredSchedules() {
      if (!this.selectedBranchId) return this.schedules
      return (this.schedules || []).filter(item => Number(item.branch_id) === Number(this.selectedBranchId))
    }
  },
  created() {
    this.isLoading = true;
    this.getUsers();
    this.getCities();
    this.loadSchedules();
  },
  watch: {
    activeTab() {
      this.loadSchedules();
    },
    cities: {
      immediate: true,
      handler(list) {
        if (this.selectedBranchId) return
        for (const city of list || []) {
          if (Array.isArray(city.children) && city.children.length) {
            this.selectedBranchId = city.children[0].id
            break
          }
        }
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('schedules', ['fetchSchedules', 'updateSchedule', 'deleteSchedule']),
    ...mapActions('users', ['getUsers']),
    ...mapActions('cities', ['getCities']),
    handleResize() {
      this.viewportWidth = window.innerWidth
    },
    async loadSchedules() {
      this.isLoading = true;
      await this.fetchSchedules({ type: this.activeTab });
      this.isLoading = false;
    },
    async onUpdateShifts(user) {
      try {
        const payload = {
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id,
          shifts: (user.shifts || []).map(shift => ({
            date: shift.date,
            start_time: shift.start_time,
            end_time: shift.end_time,
            breaks: Array.isArray(shift.breaks)
              ? shift.breaks.map(b => ({
                type: b.type,
                start: b.start || b.start_time,   // ← добавили fallback
                end: b.end || b.end_time,
                date: shift.date
              }))
              : []
          }))
        };

        console.log('Отправка данных на сервер:', payload);
        await this.$store.dispatch('schedules/updateSchedule', payload);
        ElMessage.success('Смены успешно обновлены');
      } catch (error) {
        console.error('Ошибка при обновлении смен:', error);
        ElMessage.error('Ошибка при обновлении смен');
      }
    },
    async onDeleteShifts(user) {
      try {
        await ElMessageBox.confirm(
          `Удалить все смены для сотрудника ${user.name}?`,
          'Подтверждение удаления',
          {
            confirmButtonText: 'Удалить',
            cancelButtonText: 'Отмена',
            type: 'warning'
          }
        );
        await this.deleteSchedule({
          user_id: user.id,
          city_id: user.city_id,
          branch_id: user.branch_id,
          room_id: user.room_id
        });
        ElMessage.success('Смены успешно удалены');
        this.loadSchedules();
      } catch {
        ElMessage.info('Удаление отменено');
      }
    }
  }
}
</script>



<style scoped>
.scheduler-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 20px 12px 24px;
  color: var(--cal-text-inverse);
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif;
}

.scheduler-branch-select {
  width: min(356px, 100%);
}

.scheduler-branch-select :deep(.el-select__wrapper) {
  background: var(--cal-surface-control);
  box-shadow: inset 0 0 0 1px rgba(41, 73, 130, 0.72);
  border-radius: 4px;
  min-height: 32px;
  width: 356px;
  padding-left: 10px;
  padding-right: 10px;
}

.scheduler-branch-select :deep(.el-select__placeholder),
.scheduler-branch-select :deep(.el-select__selected-item) {
  color: var(--cal-text-primary) !important;
  font-size: 18px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
}

.scheduler-branch-select :deep(.el-select__caret) {
  color: #00c3fe !important;
  font-size: 18px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.create-shift-btn {
  margin: 22px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 198px;
  min-height: 42px;
  padding: 0 18px;
  border-radius: 9px;
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
}

.tabs {
  margin-bottom: 10px;
}

.create-shift-btn {
  background: var(--appointment-primary) !important;
  border-color: transparent !important;
  color: var(--appointment-primary-text) !important;
}

.create-shift-btn:hover,
.create-shift-btn:focus,
.create-shift-btn:focus-visible,
.create-shift-btn.el-button,
.create-shift-btn.el-button:hover,
.create-shift-btn.el-button:focus,
.create-shift-btn.el-button:focus-visible {
  box-shadow: none !important;
  outline: none !important;
  border-color: transparent !important;
}

:deep(.tabs .el-tabs__header) {
  margin-bottom: 14px;
}

:deep(.tabs .el-tabs__item) {
  padding: 0 54px 0 0;
  color: rgba(255, 255, 255, 0.92);
  font-family: "Bahnschrift", "DIN Alternate", "Oswald", sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1;
}

:deep(.tabs .el-tabs__item.is-active),
:deep(.tabs .el-tabs__item:hover) {
  color: #00c3fe !important;
}

:deep(.tabs .el-tabs__active-bar) {
  background-color: #00c3fe;
  height: 1px;
}

:deep(.tabs .el-tabs__nav-wrap::after) {
  background-color: transparent;
}

@media (max-width: 768px) {
  .scheduler-page {
    padding: 12px 12px;
  }
  .scheduler-branch-select {
    width: 100%;
  }
  .create-shift-btn {
    width: 132px;
    min-height: 34px;
    padding: 0 14px;
    font-size: 14px;
    border-radius: 6px;
  }
  :deep(.tabs .el-tabs__header) {
    margin-bottom: 16px;
  }
  :deep(.tabs .el-tabs__nav-wrap) {
    overflow-x: auto !important;
    scrollbar-width: none;
  }
  :deep(.tabs .el-tabs__nav-wrap::-webkit-scrollbar) {
    display: none;
  }
  :deep(.tabs .el-tabs__nav-scroll) {
    overflow: visible !important;
  }
  :deep(.tabs .el-tabs__nav) {
    display: inline-flex;
    flex-wrap: nowrap;
    min-width: max-content;
  }
  :deep(.tabs .el-tabs__item) {
    font-size: 13px !important;
    padding: 0 14px 0 0 !important;
    white-space: nowrap;
  }
}

@media (max-width: 480px) {
  .scheduler-page {
    padding: 8px 10px;
  }
  .create-shift-btn {
    min-height: 38px;
    padding: 0 14px;
    font-size: 13px;
    width: 180px;
    max-width: 100%;
    margin-top: 14px;
  }
  :deep(.tabs .el-tabs__item) {
    font-size: 12px !important;
    padding: 0 10px 0 0 !important;
  }
}

:deep(.tabs .el-tabs__item) {
  transition: color 0.2s;
}
</style>
